export const configKeys = {
  /**
   * Config key for license info uri
   * @type {string}
   */
  LICENSE_INFO_URI_CONFIG_KEY: 'apis.license.info.uri',
};
